/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_E2_Point_1_TextInputs */

const en_visa_e2_point_1_text = /** @type {(inputs: Visa_E2_Point_1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nationality, ownership, control, and the operational reality of the enterprise are all reviewed before a strategy is recommended.`)
};

const pt_visa_e2_point_1_text = /** @type {(inputs: Visa_E2_Point_1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nacionalidade, propriedade, controle e a realidade operacional da empresa são todos revisados antes que uma estratégia seja recomendada.`)
};

const es_visa_e2_point_1_text = /** @type {(inputs: Visa_E2_Point_1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La nacionalidad, propiedad, control y la realidad operativa de la empresa se revisan antes de recomendar una estrategia.`)
};

/**
* | output |
* | --- |
* | "Nationality, ownership, control, and the operational reality of the enterprise are all reviewed before a strategy is recommended." |
*
* @param {Visa_E2_Point_1_TextInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_e2_point_1_text = /** @type {((inputs?: Visa_E2_Point_1_TextInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_E2_Point_1_TextInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_e2_point_1_text(inputs)
	if (locale === "es") return es_visa_e2_point_1_text(inputs)
	return en_visa_e2_point_1_text(inputs)
});